























import Vue, { PropOptions } from 'vue';

interface Tab {
  name: string;
  title: string;
  showFor: string[];
}

interface LocalState {
  selectedTab: string;
  previousSelectedTab: string | null;
}

interface Props {
  product: PropOptions;
  validator: PropOptions;
}

export default Vue.extend({
  name: 'ProductForm',
  props: {
    product: {
      type: Object,
    },
    validator: {
      type: Object,
    },
  } as Props,
  computed: {
    nextTab() {
      const selectedTab = this.tabs.find(tab => tab.name === this.selectedTab);
      const selectedTabIndex = this.tabs.indexOf(selectedTab);
      if (selectedTabIndex === this.tabs.length) return null;
      return this.tabs[selectedTabIndex + 1];
    },
    tabs(): Tab[] {
      if (!this.product) return [];

      //const privateSessionsProducts = ['media_library', 'course', 'event_only', 'private_space']
      const privateSessionsProducts = [];
      if (this.product.has_private_sessions) {
        privateSessionsProducts.push(this.product.product_type);
      }
      const isBundle = this.product.product_type === 'bundle';

      const tabs: Tab[] = [
        {
          name: '',
          title: isBundle
            ? this.$t('PRODUCTS.TITLE.BUNDLE_DETAILS')
            : this.$t('PRODUCTS.TITLE.PRODUCT_DETAILS'),
          showFor: [
            'media_library',
            'course',
            'event_only',
            'private_coaching',
            'bundle',
            'digital_download',
          ],
        },
        {
          name: 'private-space-details',
          title: this.$t('PRODUCTS.TITLE.PRODUCT_DETAILS'),
          showFor: ['private_space'],
        },
        /*
        {
          name: 'sales-page',
          title: this.$t('PRODUCTS.TITLE.SALES_PAGE'),
          showFor: ['media_library', 'course', 'event_only'],
        },
        */
        {
          name: 'content',
          title: this.$t('PRODUCTS.LINK.CONTENT'),
          showFor: ['media_library', 'private_space', 'private_coaching'],
        },
        {
          name: 'digital-download-content',
          title: this.$t('PRODUCTS.LINK.CONTENT'),
          showFor: ['digital_download'],
        },
        {
          name: 'lessons',
          title: this.$t('PRODUCTS.TITLE.LESSONS'),
          showFor: ['course'],
        },
        {
          name: 'included-products',
          title: this.$t('PRODUCTS.TITLE.BUNDLE_PRODUCTS'),
          showFor: ['bundle'],
        },
        {
          name: 'pricing',
          title: this.$t('PRODUCTS.TITLE.PRICING'),
          showFor: [
            'media_library',
            'course',
            'event_only',
            'private_coaching',
            'bundle',
            'digital_download',
          ],
        },
        {
          name: 'class-card',
          title: this.$t('PRODUCTS.NEW_PRODUCT_LABELS.CLASS_CARD'),
          showFor: ['punch_card'],
        },
        {
          name: 'class-card-pricing',
          title: this.$t('PRODUCTS.TITLE.PRICING'),
          showFor: ['punch_card'],
        },
        {
          name: 'upsell',
          title: this.$t('PRODUCTS.TITLE.ONE_CLICK_UPSELL'),
          showFor: [
            'media_library',
            'course',
            'event_only',
            'private_coaching',
            'bundle',
            'punch_card',
          ],
        },
        {
          name: 'product-schedule',
          title: this.$t('PRODUCTS.TITLE.PRODUCT_SCHEDULE'),
          showFor: [
            'media_library',
            'course',
            'event_only',
            'private_coaching',
          ],
        },
        {
          name: 'private-sessions',
          title: this.$t('PRODUCTS.LINK.PRIVATE_SESSIONS'),
          showFor: privateSessionsProducts,
        },
        {
          name: 'summary',
          title: this.$t('PRODUCTS.TITLE.SUMMARY'),
          showFor: [
            'media_library',
            'course',
            'event_only',
            'punch_card',
            'private_coaching',
            'bundle',
            'digital_download',
          ],
        },
      ];
      return tabs.filter(t => t.showFor.includes(this.product.product_type));
    },
  },
  data(): LocalState {
    return {
      selectedTab: '',
      previousSelectedTab: null,
    };
  },
  methods: {
    validate(value: string, oldValue: string | null): void {
      if (this.validator) {
        this.validator.validate().then(res => {
          if (res) {
            this.navigateTo(value);
          } else {
            if (value != this.previousSelectedTab) {
              this.selectedTab = oldValue ?? '';
              this.previousSelectedTab = oldValue;
            }
          }
        });
        return;
      }
      this.navigateTo(value);
    },
    navigateTo(value: string) {
      const id = this.$route.params['id'];
      let url = '';
      if (id) {
        url = `/products/${id}/edit/${value}`;
      } else {
        url = `/products/create/${value}`;
      }
      if (this.$route.path !== url) {
        this.$router.replace(url);
      }
    },
  },
  mounted() {
    const path = this.$route.path as string;
    const tab = path.slice(path.lastIndexOf('/') + 1);

    if (!this.tabs.find(t => t.name == tab)) {
      this.selectedTab = this.tabs[0].name;
      this.navigateTo(this.selectedTab);
    } else {
      this.selectedTab = tab;
    }

    this.previousSelectedTab = this.selectedTab;
  },
  watch: {
    selectedTab: 'validate',
  },
});
